export function joinDefinedValues(joiner: string, ...elements: Array<string | number | undefined>): string {
    return elements.filter(element => element !== undefined).join(joiner);
}
